import SDIcon from '../SDIcon'
import type { SDIconProps } from '../SDIcon'

const IconSearch = ({ size = 16, color = 'currentColor', ...props }: SDIconProps) => (
  <SDIcon viewBox='0 0 24 24' size={size} color={color} aria-hidden='true' {...props}>
    <g fill='none' stroke='currentColor' strokeWidth='1.9' strokeLinecap='round' strokeLinejoin='round'>
      <circle cx='11' cy='11' r='7' />
      <path d='m21 21-4.3-4.3' />
    </g>
  </SDIcon>
)

export default IconSearch
